module.exports = __webpack_public_path__ + "static/media/Other.b4aca16c.svg";